import { SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { GetEditIndividualBusinessAdapter } from '../adapters/getEditIndividualBusinessAdapter';
import { IGetEditBusinessChildBusinessResult } from '../domains/entities/getEditBusinessChildBusinessResult';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';

/**
 * 編集ページの集計の子取引情報取得UseCase
 */
export class GetEditBusinessChildBusinessUseCase {
  private repository: IBaseBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 集計に紐づく子取引情報の取得
   * @param sortType - ソートタイプ
   * @param sortTarget - ソート対象
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param filterItems - フィルターの一覧
   */
  public async execute(
    sortType: SortType,
    sortTarget: string,
    limit: number,
    offset: number,
    filterItems: FilterContentItem[]
  ): Promise<INetworkResult<IGetEditBusinessChildBusinessResult, IError>> {
    const filterItem = FilterService.convertCustomerForecastFilterItems(filterItems);
    try {
      const response = await this.repository.getBaseBusiness(sortType, limit, offset, filterItem, sortTarget, undefined);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: GetEditIndividualBusinessAdapter.adaptChildBusiness(response.status.data.result),
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
